import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { PersonalFileInfo } from '../../../shared/models/PersonalFileInfo';
import { FileUploadItemComponent } from '../fileUploadItem/fileUploadItem.component';
import { AlertService } from '../../../shared/services/alert/Alert.service';
import { RunningUploadsInfo } from '../../models/RunningUploadsInfo';

@Component({
  selector: 'app-fileuUploadArea',
  templateUrl: './fileuUploadArea.component.html',
  styleUrls: ['./fileuUploadArea.component.css']
})
export class FileuUploadAreaComponent implements OnInit {

  @Input() title!: string;
  @Input() filetypes!: string[];
  @Output() setFileInfo: EventEmitter<PersonalFileInfo> = new EventEmitter();
  @Output() setCountRunningUploads: EventEmitter<RunningUploadsInfo> = new EventEmitter();

  files: File[] = [];

  @ViewChildren('items') fileComponents!: QueryList<FileUploadItemComponent>;
  @ViewChild('fileInput') fileInput!:ElementRef;

  constructor(private alertService: AlertService) { }

  ngOnInit() {
  }

  getFiletypesDescription(): string {
    if (!this.filetypes || this.filetypes.length<1) return "Datei-Endungen: *";
    return "Datei-Endungen: "+this.filetypes.join(", ");
  }

  addFile(dFile:File) {
    let self = this;
    if (!this.filetypes || this.filetypes.length<1) {
      self.files.push(dFile);
      self.setCoundRunningUploads();
      return;
    }
    else {
      for(let ft of this.filetypes) {
        if (dFile.name.toLowerCase().endsWith("."+ft.toLowerCase())) {
          self.files.push(dFile);
          self.setCoundRunningUploads();
          return;
        }
      }
    }
    self.alertService.setWarning("Dateityp nicht zugelassen: "+dFile.name);
  }

  setCoundRunningUploads() {
    let self = this;
    var result = new RunningUploadsInfo();
    for (let item of this.fileComponents) {
      if (item.isRunning) {
        result.countRunningUploads++;
      }
      if (item.errortext) {
        result.countUploadErrors++;
      }
    }
    self.setCountRunningUploads.emit(result);
  }

  onDrop(event: any) {
    let self = this;
    let a = event;
    if (event.dataTransfer) {
      if (event.dataTransfer.files) {
        for(var item of event.dataTransfer.files) {
          let dFile = item as File;
          //self.alertService.setMessage("Datei "+dFile.name+" hinzugefügt!");
          self.addFile(dFile);
        }
      }
    }
    setTimeout(function() {
      self.startFiles();
    }, 100);

    event.preventDefault();
  }

  onDragover(event: any) {
    let a = event;
    if (event.dataTransfer) {
      if (event.dataTransfer.items) {
        for(var item of event.dataTransfer.items) {
          let ditem = item as DataTransferItem;
          let dFile = ditem.getAsFile();
        }
      }
    }
    event.preventDefault();
  }

  onSetFileInfo(fileInfo: PersonalFileInfo) {
    this.setFileInfo.emit(fileInfo);
  }

  removeFile(fileDone: File) {
    let self = this;
    let index = 0;
    for(let file of this.files) {
      if (file == fileDone) {
        this.files.splice(index, 1);
        self.setCoundRunningUploads();
        break;
      }
      index++;
    }
    setTimeout(function() {
      self.startFiles();
    }, 100);
  }

  onUpload(event: any) {
    this.alertService.setMessage("Bitte "+this.title+" auswählen!");
    let event2 = new MouseEvent('click', {bubbles: false});
    this.fileInput.nativeElement.dispatchEvent(event2);
    return false;

    event.stopPropagation();
  }

  onClearAll(event: any) {
    for(let item of this.fileComponents)     {
      item.onClear();
    }
    event.stopPropagation();
  }

  getFileSizeTotal() : number {
    let result = 0;
    for(let item of this.files)     {
      result+= item.size;
    }

    return result;
  }

  startFiles() {
    let maxRunning = 5;
    let countRunning = 0;
    for(let item of this.fileComponents)     {
      countRunning++;
      if (countRunning>=maxRunning) return;
      item.startUpload();
    }
  }


  selectFiles(event:any) {
    var self = this;
    var input = event.srcElement;
    var files = input.files as FileList;
    for(let i=0;i<files.length;i++) {
      let dFile = files[i];
      self.addFile(dFile);
    }

    setTimeout(function() {
      self.startFiles();
    }, 100);

  }

}
